import { fabric } from 'fabric';
import Editor from './Editor' 

export default class Frame {

    safetyMargin
    cuttingLine

    renderSafetyMargin = false
    renderCuttingLine = false

    constructor(safetyMargin, cuttingLine) {

        this.safetyMargin = Editor.parseToPixel(safetyMargin)
        this.cuttingLine = Editor.parseToPixel(cuttingLine)

        this.renderSafetyMargin = !this.checkIfZero(safetyMargin)
        this.renderCuttingLine = !this.checkIfZero(cuttingLine)
    }

    get safetyMarginPosition() {
        return {
            top: this.safetyMargin.top || this.safetyMargin,
            left: this.safetyMargin.left || this.safetyMargin,
            width: Editor.width - (this.safetyMargin.left || this.safetyMargin) - (this.safetyMargin.right || this.safetyMargin),
            height: Editor.height - (this.safetyMargin.top || this.safetyMargin) - (this.safetyMargin.bottom || this.safetyMargin),
        }
    }

    get cuttingLinePosition() {
        const safetyMarginPosition = this.safetyMarginPosition

        return {
            top: safetyMarginPosition.top + (this.cuttingLine.top || this.cuttingLine),
            left: safetyMarginPosition.left + (this.cuttingLine.left || this.cuttingLine),
            width: safetyMarginPosition.width - (this.cuttingLine.left || this.cuttingLine) - (this.cuttingLine.right || this.cuttingLine),
            height: safetyMarginPosition.height - (this.cuttingLine.top || this.cuttingLine) - (this.cuttingLine.bottom || this.cuttingLine),
        }
    }

    checkIfZero(object) {
        return object == 0
        // return Object.values(object).every((val, i, arr) => val === arr[0] && arr[0] === 0)
    }

    drawFrames() {
        this.drawSafetyMargin()
        this.drawCuttingLine()
    }

    drawSafetyMargin() {

        const safetyMargin  = Editor.canvas.getObjectById('safetyMargin')

        console.log('rtetet', this.renderSafetyMargin, safetyMargin, this.safetyMarginPosition)
        if (!this.renderSafetyMargin || safetyMargin) {
            return
        }

        const rect = new fabric.Rect({
            id: 'safetyMargin',
            strokeDashArray: [10, 10],
            stroke: 'red',
            strokeWidth: 1,
            fill: 'rgba(0, 0, 0, 0)',
            selectable: false,
            blocked: true,
            evented: false,
            excludeFromSVG: true,
            ...this.safetyMarginPosition
        });
          
        Editor.canvas.insertAt(rect, 1);
    }

    drawCuttingLine() {
        
        const cuttingLine  = Editor.canvas.getObjectById('cuttingLine')

        if (!this.renderCuttingLine || cuttingLine) {
            return
        }

        const rect = new fabric.Rect({
            id: 'cuttingLine',
            strokeDashArray: [10, 10],
            stroke: '#0789ed',
            strokeWidth: 1,
            fill: 'rgba(0, 0, 0, 0)',
            selectable: false,
            blocked: true,
            evented: false,
            excludeFromSVG: true,
            ...this.cuttingLinePosition
        });
          
        Editor.canvas.insertAt(rect, 1);
    }

}